import * as Actions from '../actions';
import moment from 'moment'

const initialState = {
    scheduledCourseList: [],
    currentScheduledCourse: {},
    isScheduledCourseLoaded: false,
    currentInstructors: [],
    currentStudents: [],
    allInstructors: [],
    allStudents: [],
    events: [],
    dayEvents: [],
    agenda: [],
    primary_instructor_id: null,
    notifications: [],
    studentProgress: []
}

const scheduledCourseReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_SCHEDULED_COURSE_LOADED):
            {
                return {
                    ...state,
                    isScheduledCourseLoaded: action.payload
                }
            }
        case (Actions.GET_SCHEDULED_COURSE):
            {
                return {
                    ...state,
                    currentScheduledCourse: { ...action.payload, current_scheduled_course_loaded: true }
                };
            }
        case (Actions.UPDATE_SCHEDULED_COURSE_FORM):
            {
                return {
                    ...state,
                    currentScheduledCourse: { ...state.currentScheduledCourse, ...action.payload }
                }
            }
        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    currentInstructors: action.payload.instructors,
                    currentStudents: action.payload.students,
                    allInstructors: action.payload.allInstructors.map(instructor => {
                        return {
                            ...instructor,
                            original_rel: instructor.enrolled_this_course,
                        }
                    }),
                    allStudents: action.payload.allStudents.map(student => {
                        return {
                            ...student,
                            original_rel: student.enrolled_this_course,
                        }
                    })
                }
            }
        case (Actions.GET_SCHEDULED_COURSE_LIST):
            {
                return {
                    ...state,
                    scheduledCourseList: action.payload
                }
            }
        case (Actions.TOGGLE_INSTRUCTOR):
            {
                if (action.payload.action_type === 'ADD') {
                    return {
                        ...state,
                        allInstructors: state.allInstructors.map(instructor => {
                            if (instructor.instructor_id === action.payload.instructor.instructor_id) {
                                return {
                                    ...instructor,
                                    enrolled_this_course: 1
                                }
                            }
                            else {
                                return { ...instructor }
                            }
                        })
                    }
                }
                else {
                    return {
                        ...state,
                        allInstructors: state.allInstructors.map(instructor => {
                            if (instructor.instructor_id === action.payload.instructor.instructor_id) {
                                return {
                                    ...instructor,
                                    enrolled_this_course: 0,
                                    schedule_conflict: 0,
                                    PrimaryInstructor: 0
                                }
                            }
                            else {
                                return { ...instructor }
                            }
                        })
                    }
                }
            }
        case (Actions.TOGGLE_STUDENT):
            {
                if (action.payload.action_type === 'ADD') {
                    return {
                        ...state,
                        allStudents: state.allStudents.map(student => {
                            if (student.student_id === action.payload.student.student_id) {
                                return {
                                    ...student,
                                    enrolled_this_course: 1
                                }
                            }
                            else {
                                return { ...student }
                            }
                        })
                    }
                }
                else {
                    return {
                        ...state,
                        allStudents: state.allStudents.map(student => {
                            if (student.student_id === action.payload.student.student_id) {
                                return {
                                    ...student,
                                    enrolled_this_course: 0,
                                    schedule_conflict: 0
                                }
                            }
                            else {
                                return { ...student }
                            }
                        })
                    }
                }

            }
        case (Actions.TOGGLE_PRIMARY_INSTRUCTOR):
            {
                const { instructor_id, value } = action.payload;
                
                return {
                    ...state,
                    currentScheduledCourse: { ...state.currentScheduledCourse, primary_instructor_id: instructor_id },
                    allInstructors: state.allInstructors.map(instructor => {
                        if (instructor.instructor_id === instructor_id) {
                            return {
                                ...instructor,
                                PrimaryInstructor: value,
                            }
                        } else {
                            return {
                                ...instructor,
                            }
                        }
                    })
                }
            }
        case (Actions.GET_SCHEDULED_COURSE_SCHEDULE):
            {
                return {
                    ...state,
                    events: action.payload.map(lesson => {
                        let newDate = new Date(moment(lesson.LessonDate).format('YYYY-MM-DD HH:mm:ss'))
                        return {
                            id: lesson.company_calendar_day_id,
                            title: lesson.LessonName,
                            allDay: true,
                            start: newDate,
                            end: newDate,
                            color: lesson.Color,
                            DisplayOrder: lesson.DisplayOrder,
                            LessonDescription: lesson.LessonDescription
                        }
                    })
                }
            }
        case (Actions.GET_DAY_EVENTS):
            {
                const dayEventList = action.payload.map(event => {
                    return {
                        id: event.company_calendar_event_id,
                        title: event.EventName,
                        allDay: false,
                        start: new Date(event.StartTime),
                        end: new Date(event.EndTime),
                        courseName: event.CourseName,
                        category: event.assignment_id ? 'category-assignment' : 'category-quiz',
                        eventType: event.assignment_id ? 'dayEventAssignment' : 'dayEventQuiz',
                        Color: event.Color || '#2D323E',
                        LessonDescription: event.LessonDescription,
                        Unscheduled: event.Unscheduled,
                    }
                })
                return {
                    ...state,
                    dayEvents: dayEventList
                }
            }
        case (Actions.GET_AGENDA):
            {
                return {
                    ...state,
                    agenda: action.payload
                }
            }
        case (Actions.GET_NOTIFICATIONS):
            {
                return {
                    ...state,
                    notifications: action.payload
                }
            }
        case (Actions.GET_STUDENT_PROGRESS):
            {
                return {
                    ...state,
                    studentProgress: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default scheduledCourseReducer;


// WEBPACK FOOTER //
// src/main/content/scheduled_course/store/reducers/scheduled_course.reducer.js